import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import Button from '@shared/ui/button'

import styles from './cancel-order-modal.module.scss'

interface CancelOrderModalProps {
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export default function CancelOrderModal ({
  loading = false,
  onConfirm,
  onClose,
}: CancelOrderModalProps) {
  const { t: tc } = useTranslation('common')
  const { t: to } = useTranslation('order')
  const isTablet = useMediaQuery('(max-width: 768px)')

  return (
    <div className={styles.modal}>
      <Button
        onClick={onConfirm}
        size={isTablet ? 'medium' : 'large'}
        disabled={loading}
      >
        {to('order.button.cancel')}
      </Button>
      <Button
        onClick={onClose}
        theme="grey"
        size={isTablet ? 'medium' : 'large'}
        disabled={loading}
      >
        {tc('no')}
      </Button>
    </div>
  )
}
